export default __webpack_public_path__ + "static/media/papa.e7bd9daa.png";